import React, { useEffect, useState, useMemo } from "react";

// --- Utilidades ---
const fixed2decimal = (num) => Math.round(num * 100) / 100;
const copyObject = (obj) => JSON.parse(JSON.stringify(obj));
const generateId = () => Math.random().toString(36).substr(2, 9);

// --- Custom Hook para LocalStorage ---
function useLocalStorageState(key, initialValue) {
    const [value, setValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch (error) {
            return initialValue;
        }
    });

    useEffect(() => {
        window.localStorage.setItem(key, JSON.stringify(value));
    }, [key, value]);

    return [value, setValue];
}

const MapConversion = {
    'lb': 453.59,
    'g': 1,
    'kg': 1000,
    'ml': 1,
    'l': 1000,
    'oz': 28.35
}

function conversionGramoAUnidad(unidad, cantidad) {
    return fixed2decimal(parseFloat(cantidad) / MapConversion[unidad])
}
function conversionUnidadAGramo(unidad, cantidad) {
    return fixed2decimal(parseFloat(cantidad) * MapConversion[unidad])
}



const initialRecipes = [
    {
        id: generateId(),
        name: "Pan",
        pesoUnidad: 50,
        uPU: 'g',
        precioVentaUnidad: '25',
        ingredients: {
            [generateId()]: { nombre: 'harina', p: 100, costoValorTotal: 290, value: 1000, costoCant: 453.59, base: true, uV: 'g', uC: 'lb' },
            [generateId()]: { nombre: 'agua', p: 55, costoValorTotal: 0, value: 0, costoCant: 0.001, base: false, uV: 'ml', uC: 'l' },
            [generateId()]: { nombre: 'grasa', p: 4, costoValorTotal: 1500, value: 0, costoCant: 1000, base: false, uV: 'g', uC: 'l' },
            [generateId()]: { nombre: 'sal', p: 2, costoValorTotal: 50, value: 0, costoCant: 453.59, base: false, uV: 'g', uC: 'lb' },
            [generateId()]: { nombre: 'levadura', p: 1.5, costoValorTotal: 1700, value: 0, costoCant: 500, base: false, uV: 'g', uC: 'g' },
            [generateId()]: { nombre: 'azucar', p: 8, costoValorTotal: 310, value: 0, costoCant: 453.59, base: false, uV: 'g', uC: 'lb' },
        },
        resultados: { pesoTotalMasa: 0, cantPanes: 0, costoPorPan: 0, costoMasa: 0 }
    },
    {
        id: generateId(),
        name: "Pan con Nucleo",
        pesoUnidad: 50,
        uPU: 'g',
        precioVentaUnidad: '25',
        ingredients: {
            [generateId()]: { nombre: 'harina', p: 100, costoValorTotal: 290, value: 1000, costoCant: 453.59, base: true, uV: 'g', uC: 'lb' },
            [generateId()]: { nombre: 'agua', p: 55, costoValorTotal: 0, value: 0, costoCant: 0.001, base: false, uV: 'ml', uC: 'l' },
            [generateId()]: { nombre: 'grasa', p: 4, costoValorTotal: 1500, value: 0, costoCant: 1000, base: false, uV: 'g', uC: 'l' },
            [generateId()]: { nombre: 'sal', p: 2, costoValorTotal: 50, value: 0, costoCant: 453.59, base: false, uV: 'g', uC: 'lb' },
            [generateId()]: { nombre: 'levadura', p: 1.5, costoValorTotal: 1700, value: 0, costoCant: 500, base: false, uV: 'g', uC: 'g' },
            [generateId()]: { nombre: 'nucleo', p: 1, costoValorTotal: 1800, value: 0, costoCant: 453.59, base: false, uV: 'g', uC: 'lb' },
            [generateId()]: { nombre: 'azucar', p: 8, costoValorTotal: 310, value: 0, costoCant: 453.59, base: false, uV: 'g', uC: 'lb' },
        },
        resultados: { pesoTotalMasa: 0, cantPanes: 0, costoPorPan: 0, costoMasa: 0 }
    }
];

export default function AppPanaderia() {
    const [recipes, setRecipes] = useLocalStorageState('persist-Formula-Recipes', initialRecipes);
    const [activeRecipeId, setActiveRecipeId] = useLocalStorageState('persist-Formula-ActiveId', initialRecipes[0].id);
    const [activeTab, setActiveTab] = useState('dosificacion');

    const activeRecipe = useMemo(() => { return recipes.find(r => r.id === activeRecipeId) || recipes[0] }, [activeRecipeId, recipes])

    const ingBase = useMemo(() => {
        let result = { uV: 'g' }
        try {
            Object.values(activeRecipe.ingredients).forEach(ing => {

                if (ing.base)
                    result = ing

            })

        } catch (error) {

        }
        return result
    }, [activeRecipe])

    // --- Lógica de Recetas ---
    const updateActiveRecipe = (updatedRecipe) => {
        setRecipes(recipes.map(r => r.id === updatedRecipe.id ? updatedRecipe : r));
    };

    const handleCreateRecipe = () => {
        const newRecipe = {
            id: generateId(),
            name: `Nueva Receta ${recipes.length + 1}`,
            pesoUnidad: 50,
            uPU: 'g',
            precioVentaUnidad: '25',
            ingredients: {
                [generateId()]: { nombre: 'Ingrediente 1', p: 1, costoValorTotal: 0, value: 100, costoCant: 1, base: true, uV: 'g', uC: 'g' }
            },
            resultados: { pesoTotalMasa: 0, cantPanes: 0, costoPorPan: 0, costoMasa: 0 }
        };
        setRecipes([...recipes, newRecipe]);
        setActiveRecipeId(newRecipe.id);
    };

    const handleDuplicateRecipe = () => {
        if (!activeRecipe) return;
        const duplicated = copyObject(activeRecipe);
        duplicated.id = generateId();
        duplicated.name = `${duplicated.name} (Copia)`;
        setRecipes([...recipes, duplicated]);
        setActiveRecipeId(duplicated.id);
    };

    const handleDeleteRecipe = () => {
        if (recipes.length === 1) return alert("No puedes eliminar la última receta.");
        const filtered = recipes.filter(r => r.id !== activeRecipeId);
        setRecipes(filtered);
        setActiveRecipeId(filtered[0].id);
    };


    // --- Lógica de Ingredientes ---
    const handleAddIngredient = () => {
        const newIng = { nombre: 'Nuevo', p: 0, costoValorTotal: 0, value: 0, costoCant: 1, base: false, uV: 'g', uC: 'g' };
        updateActiveRecipe({
            ...activeRecipe,
            ingredients: { ...activeRecipe.ingredients, [generateId()]: newIng }
        });
    };

    const handleDeleteIngredient = (ingId) => {
        if (activeRecipe.ingredients[ingId].base) {
            return alert("No puedes eliminar el ingrediente base. Asigna otro ingrediente como base primero.");
        }
        const updatedIngredients = copyObject(activeRecipe.ingredients);
        delete updatedIngredients[ingId];
        updateActiveRecipe({ ...activeRecipe, ingredients: updatedIngredients });
    };

    const handleSetBase = (ingId) => {
        const updatedIngredients = copyObject(activeRecipe.ingredients);
        Object.keys(updatedIngredients).forEach(k => {
            updatedIngredients[k].base = (k === ingId);
        });
        updateActiveRecipe({ ...activeRecipe, ingredients: updatedIngredients });
    };

    const handleIngredientChange = (ingId, field, value) => {
        updateActiveRecipe({
            ...activeRecipe,
            ingredients: {
                ...activeRecipe.ingredients,
                [ingId]: { ...activeRecipe.ingredients[ingId], [field]: value }
            }
        });
    };

    // --- Cálculo Principal ---
    const calc = () => {
        console.log("Calc")
        const obj = copyObject(activeRecipe.ingredients);

        // Encontrar el valor del ingrediente base
        let baseValue = 0;
        Object.keys(obj).forEach(k => {
            if (obj[k].base) baseValue = parseFloat(obj[k].value) || 0;
        });

        let suma = 0;
        let costoMasa = 0;

        Object.keys(obj).forEach(k => {
            const element = obj[k];
            // Si no es base, calcular su peso (value) en base a su porcentaje (p)
            if (!element.base) {
                element.value = fixed2decimal((parseFloat(element.p) || 0) / 100 * baseValue);
            }
            suma += parseFloat(element.value) || 0;

            let costoUnidad = (parseFloat(element.costoValorTotal) || 0) / (parseFloat(element.costoCant) || 0);

            costoUnidad = isNaN(costoUnidad) || !isFinite(costoUnidad) ? 0 : costoUnidad


            costoMasa += fixed2decimal(costoUnidad * (parseFloat(element.value) || 0));
        });

        const cp = parseFloat(activeRecipe.pesoUnidad) > 0 ? fixed2decimal(suma / parseFloat(activeRecipe.pesoUnidad)) : 0;
        const costoPorPan = cp > 0 ? fixed2decimal(costoMasa / cp) : 0;

        updateActiveRecipe({
            ...activeRecipe,
            ingredients: obj,
            resultados: { pesoTotalMasa: fixed2decimal(suma), cantPanes: cp, costoPorPan: costoPorPan, costoMasa: costoMasa }
        });
    };

    if (!activeRecipe) return null;

    return (
        <div className="p-1  font-sans text-gray-800">
            {/* Header / Selector de Recetas */}
            <div className="flex flex-col  items-center mb-6 bg-gray-100 p-1 rounded shadow-sm">
                <div className="flex items-center">
                    <label className="text-sm font-bold text-gray-600 block mb-1 mr-1">Seleccionar Receta</label>
                    <select
                        className="border p-1 rounded"
                        value={activeRecipeId}
                        onChange={(e) => { setActiveRecipeId(e.target.value); setTimeout(calc, 300) }}
                    >
                        {recipes.map(r => <option key={r.id} value={r.id}>{r.name}</option>)}
                    </select>
                </div>
                <div className="flex  mt-4 ">
                    <button className="bg-blue-500 text-white px-3 py-2 rounded text-sm hover:bg-blue-600" onClick={handleCreateRecipe}>Nueva</button>
                    <button className="bg-gray-500 text-white px-3 py-2 rounded text-sm hover:bg-green-600" onClick={handleDuplicateRecipe}>Duplicar</button>
                    <button className="bg-red-500 text-white px-3 py-2 rounded text-sm hover:bg-red-600" onClick={handleDeleteRecipe}>Eliminar</button>
                </div>
                <div className="flex items-center mt-2">
                    <span className="font-bold mr-2">Receta:</span>
                    <input
                        type="text"
                        className="border p-1 rounded"
                        value={activeRecipe.name}
                        onChange={(e) => updateActiveRecipe({ ...activeRecipe, name: e.target.value })}
                    />
                </div>
            </div>

            {/* Ajustes Generales de la Receta */}
            <div className="flex flex-col  mb-2 ml-1 ">

                <div className="flex items-center">
                    <span className="font-bold mr-2">Peso Unidad (crudo):</span>

                    <input
                        type="number" step="0.01"
                        className="border p-1 w-20 rounded-s h-8"
                        value={conversionGramoAUnidad(activeRecipe.uPU, activeRecipe.pesoUnidad)}
                        onChange={(e) => updateActiveRecipe({ ...activeRecipe, pesoUnidad: conversionUnidadAGramo(activeRecipe.uPU, e.target.value) })}
                    />
                    <select
                        className="border p-1 rounded-e h-8 bg-gray-100"
                        value={activeRecipe.uPU}
                        onChange={(e) => updateActiveRecipe({ ...activeRecipe, uPU: e.target.value })}
                    >
                        {Object.keys(MapConversion).map(u => <option key={u} value={u}>{u}</option>)}
                    </select>
                </div>

                <div className="flex items-center mt-2">
                    <span className="font-bold mr-2">Precio Venta Unidad:</span>

                    <input
                        type="number" step="0.01"
                        className="border p-1 w-20 rounded-s h-8"
                        value={activeRecipe.precioVentaUnidad}
                        onChange={(e) => updateActiveRecipe({ ...activeRecipe, precioVentaUnidad: e.target.value })}
                    />
                </div>
            </div>

            {/* Pestañas */}
            <div className="flex border-b mb-4">
                <button
                    className={`p-1 px-4 ${activeTab === 'dosificacion' ? 'border-b-2 border-blue-500 font-bold text-blue-600' : 'text-gray-500'}`}
                    onClick={() => setActiveTab('dosificacion')}
                >
                    Dosificación
                </button>
                <button
                    className={`p-1 px-4 ${activeTab === 'costos' ? 'border-b-2 border-blue-500 font-bold text-blue-600' : 'text-gray-500'}`}
                    onClick={() => setActiveTab('costos')}
                >
                    Costos
                </button>
            </div>

            {/* Contenido Pestaña Dosificación */}
            {activeTab === 'dosificacion' && (
                <div className="border rounded shadow-sm w-fit">
                    <div className="bg-gray-200 p-1 font-bold  border-b">Proporción y Pesos</div>
                    <div className="p-1">
                        <div className="">
                            <div className="flex font-bold border-b text-center">
                                <div className="p-1 w-6 "></div>
                                <div className="p-1 w-24 ml-1">Ingrediente</div>
                                <div className="p-1 w-12">%</div>
                                <div className="p-1 w-16">Peso</div>
                                <div className="p-1 "></div>
                            </div>
                            <div className="flex flex-col">
                                {Object.keys(activeRecipe.ingredients).map(key => {
                                    const ing = activeRecipe.ingredients[key];
                                    return (
                                        <div key={key} className={`flex py-1 ${ing.base ? "bg-blue-50" : ""}`}>
                                            <div className="p-1  text-center ">
                                                <input type="radio" className="w-6" checked={ing.base} onChange={() => handleSetBase(key)} />
                                            </div>
                                            <div className=" ">
                                                <input type="text" step="0.01" className="border p-1 ml-1 h-8  w-24" value={ing.nombre} onChange={(e) => handleIngredientChange(key, 'nombre', e.target.value)} />
                                            </div>
                                            <div className=" ">
                                                <input type="number" step="0.01" className={`border p-1 w-12 ml-1 h-8 disabled:bg-gray-100 ${ing.base ? 'opacity-0' : ''}`} value={ing.p} onChange={(e) => handleIngredientChange(key, 'p', e.target.value)} />
                                            </div>
                                            <div className=" ">
                                                <select
                                                    className=" p-1 border bg-gray-100 ml-1 h-8"
                                                    value={ing.uV}
                                                    onChange={(e) => handleIngredientChange(key, 'uV', e.target.value)}
                                                >
                                                    {Object.keys(MapConversion).map(u => <option key={u} value={u}>{u}</option>)}
                                                </select>
                                            </div>
                                            <div className=" ">
                                                <input type="number" step="0.01" disabled={!ing.base} className="border p-1 h-8  w-16 disabled:bg-gray-100" value={conversionGramoAUnidad(ing.uV, ing.value)} onChange={(e) => handleIngredientChange(key, 'value', conversionUnidadAGramo(ing.uV, e.target.value))} />
                                            </div>

                                            <div className="p-1  text-center ">
                                                <button onClick={() => handleDeleteIngredient(key)} className="text-red-500 font-bold hover:text-red-700">X</button>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <button className="mt-2 mb-1 bg-gray-200 hover:bg-gray-300 text-sm py-1 px-3 rounded" onClick={handleAddIngredient}>+ Añadir Ingrediente</button>
                    </div>
                </div>
            )}

            {/* Contenido Pestaña Costos */}
            {activeTab === 'costos' && (
                <div className="border rounded shadow-sm w-fit">
                    <div className="bg-gray-200 p-1 font-bold  border-b">Costo Ingredientes</div>
                    <div className="p-1">
                        <div className="flex font-bold text-center border-b">
                            <div className="p-1 w-24">Ingrediente</div>
                            <div className="p-1 w-20">Precio</div>
                            <div className="p-1 w-20">Peso</div>

                        </div>
                        <div className="flex flex-col">
                            {Object.keys(activeRecipe.ingredients).map(key => {
                                const ing = activeRecipe.ingredients[key];
                                return (
                                    <div key={key} className="flex items-center py-1">
                                        <div className=" w-24 font-semibold text-gray-700">{ing.nombre}</div>
                                        <div className="">
                                            <input type="number" step="0.01" className="border p-1 h-8 w-20" value={ing.costoValorTotal} onChange={(e) => handleIngredientChange(key, 'costoValorTotal', e.target.value)} />
                                        </div>
                                        <div className=" ">
                                            <select
                                                className="border ml-1 bg-gray-100  p-1 h-8"
                                                value={ing.uC}
                                                onChange={(e) => handleIngredientChange(key, 'uC', e.target.value)}
                                            >
                                                {Object.keys(MapConversion).map(u => <option key={u} value={u}>{u}</option>)}
                                            </select>
                                        </div>
                                        <div className=" ">
                                            <input type="number" step="0.01" className="border p-1 h-8  w-20" value={conversionGramoAUnidad(ing.uC, ing.costoCant)} onChange={(e) => handleIngredientChange(key, 'costoCant', conversionUnidadAGramo(ing.uC, e.target.value))} />
                                        </div>

                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            )}

            {/* Botón de Cálculo y Resultados */}
            <div className="mt-4 flex flex-col  items-start  bg-gray-50 p-2 rounded border">
                <button
                    className="bg-green-700 text-white font-bold py-2 px-6 rounded shadow  mb-1 "
                    onClick={calc}
                >
                    Calcular
                </button>

                <div className="flex flex-col text-sm ">
                    <div className="flex items-center ">
                        <span className="font-bold">Masa Total:</span>
                        <span className="ml-2">{conversionGramoAUnidad(ingBase.uV, activeRecipe.resultados.pesoTotalMasa)} {ingBase.uV}</span>
                    </div>
                    <div className="flex items-center ">
                        <span className="font-bold">Cantidad de Unidades:</span>
                        <span className="ml-2">{activeRecipe.resultados.cantPanes}</span>
                    </div>
                    <div className="flex">
                        <div className="flex items-center">
                            <span className="font-bold">Costo por Unidad:</span>
                            <span className="ml-2">${activeRecipe.resultados.costoPorPan}</span>
                        </div>
                        <div className="flex items-center ml-2">
                            <span className="font-bold">Ganancia:</span>
                            <span className="ml-2">${fixed2decimal(parseFloat(activeRecipe.precioVentaUnidad) - parseFloat(activeRecipe.resultados.costoPorPan))}</span>
                        </div>

                    </div>

                    <div className="flex">
                        <div className="flex items-center">
                            <span className="font-bold">Costo Masa:</span>
                            <span className="ml-2">${activeRecipe.resultados.costoMasa}</span>
                        </div>
                        <div className="flex items-center ml-2">
                            <span className="font-bold">Ganancia:</span>
                            <span className="ml-2">${fixed2decimal((parseFloat(activeRecipe.precioVentaUnidad) - parseFloat(activeRecipe.resultados.costoPorPan)) * parseFloat(activeRecipe.resultados.cantPanes))}</span>
                        </div>

                    </div>

                </div>
            </div>

            <div className="bg-gray-400 mt-2 mb-1 p-1">
                <div>
                    <div className="font-bold text-center">Calculadora Masas 0.2b</div>
                    <div>Desarrollador: Antonio David Perera Calás</div>
                    <div>Telf: 50957806</div>
                </div>

            </div>
        </div>
    );
}

